import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/card';
import { Separator } from '../ui/separator';
import { Button } from '../ui/button';
import { StatusBadge } from './StatusBadge';
import { SummaryItem } from './SummaryItem';

/**
 * Vista de resultado tras enviar el formulario de alta exitosamente.
 *
 * @param {object} form        datos del formulario
 * @param {boolean} noPhone    si se marcó "sin teléfono"
 * @param {object} result      respuesta del backend {email_welcome, email_activation, ...}
 * @param {function} onReset   handler para "Nueva alta"
 */
export function SubmittedView({ form, noPhone, result, onReset }) {
  return (
    <div className="page-container">
      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        style={{ maxWidth: '680px', margin: '0 auto', width: '100%', paddingTop: '20px' }}
      >
        <Card style={{ border: '2px solid #3aaa62', overflow: 'hidden', boxShadow: '0 8px 40px rgba(26,92,46,0.12)' }}>
          <div style={{ background: 'linear-gradient(135deg, #1a5c2e, #3aaa62)', padding: '32px', textAlign: 'center' }}>
            <img src="/valoriza-logo.svg" alt="Valoriza" style={{ height: '32px', marginBottom: '20px' }} />
            <div style={{ fontSize: '52px', marginBottom: '12px' }}>🎉</div>
            <h2
              data-testid="cau-form-success-title"
              style={{ fontFamily: 'Space Grotesk', fontSize: '26px', fontWeight: 700, color: '#fff', margin: 0 }}
            >
              Alta procesada correctamente
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px', marginTop: '8px' }}>
              Correos enviados a <strong>{form.correo_personal}</strong>
            </p>
          </div>
          <CardContent style={{ padding: '28px 32px' }}>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '24px' }}>
              <StatusBadge label="Bienvenida" status={result?.email_welcome?.status} />
              <StatusBadge label="Activación" status={result?.email_activation?.status} />
            </div>
            <Separator style={{ marginBottom: '20px' }} />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '14px', marginBottom: '24px' }}>
              <SummaryItem label="Nombre" value={form.nombre} />
              <SummaryItem label="Correo corporativo" value={form.correo_corporativo} />
              <SummaryItem label="Centro de Coste" value={form.lugar_trabajo} />
              <SummaryItem label="Incorporación" value={form.fecha_incorporacion} />
              <SummaryItem label="Teléfono" value={noPhone ? 'No disponible' : form.telefono} />
            </div>
            <Button
              data-testid="cau-form-new-alta-button"
              onClick={onReset}
              style={{ width: '100%', background: '#1a5c2e', color: '#fff', height: '44px', fontSize: '15px', fontWeight: 600 }}
            >
              ➕ Nueva Alta
            </Button>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}

export default SubmittedView;
